import Vue from 'vue'
import OToaster from '@/components/OToaster'

Vue.use(OToaster)
